import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';
const API_TIMEOUT = Number(process.env.REACT_APP_API_TIMEOUT || 10000);

const api = axios.create({
  baseURL: API_BASE,
  timeout: API_TIMEOUT,
});

export const registerUser = async (email, login, password) => {
  try {
    const response = await api.post('/auth/register', {
      password,
      login,
      email
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const loginUser = async (login, password) => {
  try {
    const response = await api.post('/auth/login', {
      password,
      login
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyToken = async () => {
  try {
    const token = getAuthToken();
    if (!token) return false;

    const response = await api.post('/auth/validate-token', {
      token,
    });
    console.log(response.data["is-valid"]);
    return response.data["is-valid"];

  } catch (error) {
    return false;
  }
};

export const setAuthToken = (token) => {
  const expires = new Date();
  const isSafari = () => {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  };
  expires.setTime(expires.getTime() + 24 * 60 * 60 * 1000 * 5 ); // 5 дней
  const secureAttr = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `token=${token}; path=/; expires=${expires.toUTCString()}; SameSite=Lax${secureAttr}`;
  if (isSafari()) {
    try {
      localStorage.setItem('authToken', token);
    } catch (e) {
    }
  }
};

export const getAuthToken = () => {
  // Checking for Safari
  const isSafari = () => {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  };
  if (isSafari()) {
    return localStorage.getItem("authToken");
  }

  const cookies = document.cookie.split(';');
  const tokenCookie = cookies.find(c => c.trim().startsWith('token='));
  return tokenCookie ? tokenCookie.split('=')[1] : null;
};

export const logout = () => {
  document.cookie = 'token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
  window.location.href = '/login';
};

export const isAuthenticated = async () => {
  // F-20 dev/demo bypass: every "protected" page (Main, HedgeFlowMonitorLive,
  // ExecutionLiveFeedLive, ReconciliationAlertsLive, etc.) calls this and
  // navigates to /login when it returns false. For internal F-12 + Sim
  // verification we want all pages to render without login. Restore
  // `return await verifyToken();` to re-enable auth.
  return true;
};
